import { CardComponentProps } from "@~/types/types";
import { SocialProofMessage } from "@JohnLewisPartnership/jl-design-system/dist/components/social-proof-message/SocialProofMessage";
import { useSocialProofMessages } from "@~/contexts/SocialProofMessagesContext/SocialProofMessagesContext";

export function SocialProofMessaging({
  product,
}: Pick<CardComponentProps, "product">) {
  const { messages } = useSocialProofMessages();

  const getSocialProofMessage = () => {
    const productMessage = messages.filter(
      (data) => data.productId === product.aliases.pimProductId,
    );
    return productMessage.length > 0 ? productMessage[0]?.messages : null;
  };

  const message = getSocialProofMessage();

  if (!message) {
    return null;
  }
  return (
    <SocialProofMessage message={`${message[0]?.title}`}></SocialProofMessage>
  );
}
